import styled from 'styled-components';

const APT_ColorCircleInformer = styled.div`
  right: 4px;
  top: 4px;
  position: absolute;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  &.Validated {
    background-color: #3accac;
  }
  &.NotValidated {
    background-color: ${(p) => p.theme.color.gold};
  }
  &.Blocked {
    background-color: ${props => props.theme.color.error};
  }
`;

const APT_ImgWrapper = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  min-width: 100px;
  margin: 1em 2em 1em 0;
  img {
    width: 100%;
    height: 100%;
  }
`;

const APT_PatientSection = styled.div`
  display: flex;
  align-items: center;
  p {
    font-size: 24px;
    margin: 0 0 0.4em;
    line-height: 80%;
    width: 100%;
    > span {
      display: inline-block;
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      &.Blocked {
        color: ${props => props.theme.color.error};
      }
      &.NotValidated {
        color: #f1bc55;
      }
    }
  }
  .patient-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    > div {
      padding-right: 2em;
      span {
        color: ${props => props.theme.color.label};
        font-size: 0.9em;
      }
    }
    button {
      margin-top: 0.3em;
      border-radius: 4px;
      border: solid 2px ${props => props.theme.color.primary};
      font-size: 0.875em;
      font-weight: 500;
      color: ${props => props.theme.color.primary};
      padding: 0.5em;
      min-width: 90px;
      background: #fff;
      transition: opacity 0.25s ease-in-out;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
`;

const APT_Section = styled.div`
  padding: 30px;
  border-bottom: solid 1px ${props => props.theme.color.border};
  display: flex;
  align-items: center;
  &:last-of-type {
    border-bottom: none;
  }
  & > div {
    box-sizing: border-box;
    > div {
      &:not(:last-of-type) {
        margin-bottom: 1em;
      }
      > span {
        color: ${props => props.theme.color.label};
        font-size: 0.9em;
      }
    }
    &:not(.full-width):nth-of-type(1) {
      border-right: solid 1px ${props => props.theme.color.border};
      width: 60%;
    }
    &:nth-of-type(2) {
      padding-left: 30px;
      width: 40%;
    }
  }
`;

const APT_ServiceInfo = styled.span`
  font-size: 14px;
  color: ${props => props.theme.color.label};
`;

export {
  APT_ColorCircleInformer,
  APT_ImgWrapper,
  APT_PatientSection,
  APT_Section,
  APT_ServiceInfo
};
